let unmountPromise: Promise<void> | null = null
let resolveUnmount: (() => void) | null = null

export function waitUnmount() {
  return unmountPromise ?? Promise.resolve()
}

export function setUnmountPending() {
  unmountPromise = new Promise<void>((resolve) => {
    resolveUnmount = resolve
  })
}

export function finishUnmount() {
  resolveUnmount?.()
  unmountPromise = null
  resolveUnmount = null
}
